var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-social-news" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex justify--space-between align--center vuestic-social-news__text-with-button",
      },
      [
        _c("span", { staticClass: "text" }, [
          _vm._v("That what users have posted about your business."),
        ]),
        _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
          _c("button", { staticClass: "btn btn-micro btn-primary" }, [
            _vm._v("VIEW"),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "d-flex justify--space-around vuestic-social-news__photo-list",
      },
      _vm._l(_vm.news, function (pieceOfNews, index) {
        return _c("div", {
          key: index,
          staticClass: "vuestic-social-news__photo-list__photo",
          style: `background: url(${pieceOfNews.photoURL})`,
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }